import React from 'react';
import { View, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';
import Button, { BUTTON_TYPES } from '../../Button';
import Icon from '../../Icon';
import Modal from '../../Modal';

const EventCancelModal = ({ visible, onClose, onSubmit, onCancel }) => {
  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.scroll}>
          <ScrollView>
            <View style={stylesModal.innerWrap}>
              <TouchableOpacity onPress={onClose} style={stylesModal.close}>
                <Icon name="cancel" style={stylesModal.iconClose} />
              </TouchableOpacity>
              <BaseText style={stylesModal.title}>Cancel Event</BaseText>
              <Icon name="warning" style={stylesModal.centerIcon} />
              <BaseText style={stylesModal.titleMessage}>
                Are you sure you would like to cancel?
              </BaseText>
              <BaseText style={stylesModal.message}>
                By Canceling this event you will not be able to get this back and will need to
                recreate from scratch
              </BaseText>
              <Button
                label="Save Event"
                type={BUTTON_TYPES.OUTLINED}
                style={stylesModal.submit}
                labelStyle={CommonStyles.h2}
                onPress={onSubmit}
              />
              <Button
                label="Cancel Event"
                style={stylesModal.submit}
                labelStyle={CommonStyles.h2}
                onPress={onCancel}
              />
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const stylesModal = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.p3,
    ...CommonProperties.centerAlignment,
  },
  scroll: {
    width: '100%',
  },
  innerWrap: {
    backgroundColor: 'white',
    ...CommonProperties.p5,
    ...CommonProperties.borderRadius2,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    ...CommonProperties.h1,
    ...CommonProperties.mb3,
  },
  close: {
    position: 'absolute',
    top: scale(14),
    right: scale(12),
  },
  iconClose: {
    color: Color.primary,
    fontSize: 24,
  },
  centerIcon: {
    fontSize: 72,
    color: Color.primary,
    ...CommonProperties.my5,
  },
  titleMessage: {
    ...CommonProperties.h2,
    textAlign: 'center',
    ...CommonProperties.my3,
  },
  message: {
    ...CommonProperties.h3,
    textAlign: 'center',
  },
  submit: {
    maxWidth: scale(240),
    width: '100%',
    ...CommonProperties.mt5,
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py3,
  },
});

export default EventCancelModal;
